// extracted by mini-css-extract-plugin
export default {"mainPanel":"Editor_mainPanel__vwq85","root":"Editor_root__9JRhg","container":"Editor_container__-UVGa"};